import { UsersApi } from "@/api/users";
import { AddAffiliateRequest } from "@/api/users/types";
import { useUIStore } from "@/stores";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { QueryKey } from "@/utils";

export const useAddAffiliate = () => {
  const notify = useNotify();
  const { closeModal } = useUIStore();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: AddAffiliateRequest) => {
      closeModal();
      return UsersApi.addAffiliate(body);
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.AFFILIATE_USER] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.AFFILIATE_ACQUIRED_USERS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.AFFILIATE_EARNINGS] });
      notify("Acquired user is added successfully!", { type: "success" });
    },
  });

  return { addAffiliate: mutate, isAddAffiliateLoading: isPending };
};
